module.exports = __webpack_public_path__ + "static/bg-08eb4e654ff42df36e519676c0a9b2f0.jpg";